import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from './New';

const WizardStepWrapperTemplatePicker = ({ resource, ...rest }) => {
  return <WizardStepWrapperTemplate resource={resource} {...rest} />;
};

WizardStepWrapperTemplatePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default WizardStepWrapperTemplatePicker;
